module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "img-fluid w-100",
    attrs: {
      "src": require("../assets/joinus.jpg"),
      "alt": "joinusbanner"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "feature-area"
  }, [_c('div', {
    staticClass: "mbx"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "mbxwrap"
  }, [_c('router-link', {
    staticClass: "underline",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('span', [_vm._v("/")]), _vm._v(" "), _c('em', [_vm._v("加入我们")])], 1)])])])])]), _vm._v(" "), _c('section', {
    staticClass: "feature-area paddingtop30 paddingbottom30"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "scd_r"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "join"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "space_hx"
  }, [_vm._v(" ")]), _vm._v(" "), _c('table', {
    staticClass: "j_c",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_vm._m(4), _vm._v(" "), _vm._l((_vm.recruit_info_list), function(list, index) {
    return _c('tr', {
      class: {
        rowcolor: index % 2 == 1
      }
    }, [_c('td', [_vm._v(_vm._s(list.positionNm))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(list.recruitNum))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(list.workplace))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(list.releaseDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(list.deadline))])])
  })], 2)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-9"
  }, [_c('div', {
    staticClass: "nytit pull-left"
  }, [_vm._v("加入我们")]), _vm._v(" "), _c('menu', {
    staticClass: "menu pull-left",
    attrs: {
      "id": "menu"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "r_name"
  }, [_c('span', [_vm._v("人才招聘")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "j_a"
  }, [_vm._v("人才是公司发展的重要因素，人才是公司最大的财富，本公司秉承以人为本，公平、公正、公开的经营管理原则, 为员工创造一个施展才华的舞台，通过丰裕的工作内容、优越的工作环境以及和谐的工作氛围，实现企业与个人的良性互动。公司提供具有竞争力的薪酬、福利及晋升机会, 诚邀各方英才加入北京泽浩天科技发展有限公司工作团队。"), _c('br'), _vm._v("\n              我们真诚期待你的加入！")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "j_b"
  }, [_c('b', [_vm._v("人事部门联络资料")]), _vm._v(" "), _c('p', [_vm._v("请有意者将个人简历、照片及学历证明复印件等相关资料发送至")]), _vm._v(" "), _c('p', [_vm._v("邮箱:"), _c('a', {
    attrs: {
      "href": "mailto:zehaotian@139.com"
    }
  }, [_vm._v(" zehaotian@139.com")])]), _vm._v(" "), _c('p', [_vm._v("电话: "), _c('a', {
    attrs: {
      "href": "tel:010-67047381"
    }
  }, [_vm._v("010-67047381")]), _vm._v("    联络人："), _c('span', [_vm._v("王先生")])]), _vm._v(" "), _c('b', [_vm._v("公司目前招聘岗位如下:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("职位名称")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("招聘人数")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("工作地点")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("发布日期")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("截止日期")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f6486aa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/JoinUs.vue
// module id = 304
// module chunks = 2